/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineLangItemViewModel } from "../types/ClassroomDisciplineLangItemViewModel.ts";

export const classroomDisciplineLangItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  cultureInfo: z.string().nullish(),
  description: z.string().nullish(),
  instruction: z.string().nullish(),
}) as unknown as ToZod<ClassroomDisciplineLangItemViewModel>;
